<a class="utility align-items-center" (click) ="doAction()">
    <img class="icon" [src]="imgSrc" alt="">
    <div class="leftSide" [class.noBorder]= "lastItem">
        <span>{{title}}</span>
        <span style="margin-left: 10px;" class="mr-auto"><i class="farsiNumber">{{appVersion}}</i></span>
        <span *ngIf="showBadge" class="notification"></span>
        <img src="assets/img/right-arrow.svg" alt="">
    </div>
</a>
